// extracted by mini-css-extract-plugin
module.exports = {"item":"SimpleAccordion_item__arRo2","sidenavLayout":"SimpleAccordion_sidenavLayout__D8Ngl"};